// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import {
  DELETE_TIME_CLOCK,
  EXPORT_TIME_CLOCKS,
  GET_TIME_CLOCK_DETAILS,
  GET_TIME_CLOCK_HOURS_WORKED,
  GET_TIME_CLOCK_LIST,
} from '~/utils/constants/actionType';
import { IQueryParamTimeClock } from '~/utils/interface/timeClock';
import timeClockApi from '~/apis/timeClock';
import { IParamsHoursWorked } from '~/utils/interface/payroll';

export const getTimeClockList = createAsyncThunk(
  GET_TIME_CLOCK_LIST,
  async (params: IQueryParamTimeClock, { rejectWithValue }) => {
    try {
      const resp = await timeClockApi.getTimeClockList(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteTimeClock = createAsyncThunk(
  DELETE_TIME_CLOCK,
  async (timeClockId: string, { rejectWithValue }) => {
    try {
      const resp = await timeClockApi.deleteTimeClock(timeClockId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getTimeClockDetails = createAsyncThunk(
  GET_TIME_CLOCK_DETAILS,
  async (timeClockId: string, { rejectWithValue }) => {
    try {
      const resp = await timeClockApi.getTimeClockDetails(timeClockId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const exportTimeClocks = createAsyncThunk(
  EXPORT_TIME_CLOCKS,
  async (timeZone: string, { rejectWithValue }) => {
    try {
      const resp = await timeClockApi.exportTimeClocks(timeZone);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getTimeClockHoursWorked = createAsyncThunk(
  GET_TIME_CLOCK_HOURS_WORKED,
  async (params: IParamsHoursWorked, { rejectWithValue }) => {
    try {
      const resp = await timeClockApi.getTimeClockHoursWorked(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
